import { Modal } from "antd";
import React from "react";

export default function Locations({ setOpenLocation, openLocation }) {
  return (
    <Modal
      style={{ top: "40px", width: "900px" }}
      title="O'zgartirish"
      open={openLocation}
      width={800}
      //   loading={loadVagon}
      onOk={() => {
        setOpenLocation(false);
      }}
      onCancel={() => {
        console.log("Modal closed via Cancel button or close icon.");
        setOpenLocation(false);
      }}
      footer={[]}
    ></Modal>
  );
}
